module.exports = __webpack_public_path__ + "img/inst-audio-btn.a80b9d28.png";